(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-guide-carousel"] && !Shopify.designMode) return;
  try {
    
  // Helper function to determine how many items to show in carousel
  function getNumProductsToShow(container) {
    var show = parseInt(container.dataset.show);
    var max = parseInt(container.dataset.max);

    // More items in collection than need to be shown
    if (show <= max) {
      return show;
    }

    // Number of products is an even number, so show one less to ensure there is a "middle"
    if (max % 2 === 0) {
      max -= 1;
    }
    return Math.max(max, 0); // Edge case of one product; still want to show it
  }

  // Helper function to get root carousel element
  function getCarouselFromEvent(event) {
    var carousel = event.currentTarget;
    while (!carousel.classList.contains('fit-guide-carousel')) {
      carousel = carousel.parentElement;
    }
    return carousel;
  }

  // Helper function to get parent collection wrapper element
  function getCollectionFromEvent(event) {
    var collection = event.currentTarget;
    while (!collection.classList.contains('collection-wrapper')) {
      collection = collection.parentElement;
    }
    return collection;
  }

  function handleCollectionSelectEvent(event) {
    event.preventDefault();
    var link = event.currentTarget;
    var targetCollection = link.dataset.target;
    var carousel = getCarouselFromEvent(event);

    // Set collection link as selected
    carousel.querySelectorAll('.collection-selector a').forEach(function(collectionLink) {
      if (collectionLink.dataset.target == targetCollection) {
        collectionLink.classList.add('selected');
      } else {
        collectionLink.classList.remove('selected');
      }
    });

    // Toggle visibility of selected collection
    carousel.querySelectorAll('.collection-wrapper').forEach(function(collection) {
      if (collection.dataset.collection === targetCollection) {
        collection.classList.remove('hidden');
        // If no product currently selected, select the middle one
        if (!collection.querySelector('.selected-product:not(.hidden)')) {
          processCarouselDirection(collection, 'init');
        }
      } else {
        collection.classList.add('hidden');
      }
    });
  }

  // Toggle visibility of selected product
  function selectProduct(collection, id) {
    // Mark product on carousel as selected
    collection.querySelectorAll('.products-container .product').forEach(function(product) {
      if (product.dataset.target === id) {
        product.classList.add('selected');
      } else {
        product.classList.remove('selected');
      }
    });

    // Show selected product fit guide info
    collection.querySelectorAll('.selected-product').forEach(function(product) {
      if (product.dataset.id === id) {
        product.classList.remove('hidden');
      } else {
        product.classList.add('hidden');
      }
    });
  }

  function handleProductSelectEvent(event) {
    var product = event.currentTarget;
    var collection = getCollectionFromEvent(event);
    var current = collection.querySelector('.products-container .product.selected');

    // Get direction and number of moves
    var direction = 'init'
    var move = parseInt(product.dataset.index) - parseInt(current.dataset.index);
    if (move > 0) {
      direction = 'next';
    } else if (move < 0) {
      direction = 'prev'
    } else {
      return;
    }

    // Move
    for (var i = 0; i < Math.abs(move); i++) {
      processCarouselDirection(collection, direction);
    }
  }

  function processCarouselDirection(collection, direction) {
    var productsContainer = collection.querySelector('.products-container');

    if (direction === 'prev') {
      // Get new product to be displayed
      var newProductIndex = parseInt(productsContainer.querySelector('.product:first-child').dataset.index) - 1;

      // Case where the current first product shown is the first block.
      // Loop to the back of the list (i.e. index `max - 1`) for new product
      if (newProductIndex < 0) {
        newProductIndex = productsContainer.dataset.max - 1;
      }

      // Add/Remove nodes
      var removeProductIndex = parseInt(productsContainer.querySelector('.product:last-child').dataset.index);
      removeNode(collection, removeProductIndex);
      insertNode(collection, newProductIndex, 'start');
    } else if (direction === 'next') {
      // Get new product to be displayed
      var newProductIndex = parseInt(productsContainer.querySelector('.product:last-child').dataset.index) + 1;

      // Case where the current last product shown is the last block.
      // Loop to the front of the list (i.e. index `0`) for new product
      if (newProductIndex >= productsContainer.dataset.max) {
        newProductIndex = 0;
      }

      // Add/Remove nodes
      var removeProductIndex = parseInt(productsContainer.querySelector('.product:first-child').dataset.index);
      removeNode(collection, removeProductIndex);
      insertNode(collection, newProductIndex);
    } else if (direction === 'init') {
      // Do nothing - should just select a product
    } else {
      console.warn(direction, 'unsupported');
      return;
    }

    // Select product
    if (getNumProductsToShow(productsContainer) > 0) { // Ensure there is a product to select
      var middleIndex = (getNumProductsToShow(productsContainer) + 1) / 2;
      var product = productsContainer.querySelector('.product:nth-child(' + middleIndex + ')');
      if (product) {
        selectProduct(collection, product.dataset.target);
      }
    }
  }

  // Handle click event on carousel arrows
  // Buttons have a data-direction
  function handleCarouselNavEvent(event) {
    processCarouselDirection(getCollectionFromEvent(event), event.currentTarget.dataset.direction);
  }

  // Handle start of touch event and store position in data-touch-start
  function handleTouchStartEvent(event) {
    var collection = getCollectionFromEvent(event);
    var productsContainer = carousel.querySelector('.products-container');
    productsContainer.dataset.touchStart = event.changedTouches[0].screenX;
  }

  // Handle end of touch event and determine direction of swipe
  function handleTouchEndEvent(event) {
    var collection = getCollectionFromEvent(event);
    var productsContainer = collection.querySelector('.products-container');
    productsContainer.dataset.touchEnd = event.changedTouches[0].screenX;

    // Get start and end positions
    var start = parseInt(productsContainer.dataset.touchStart);
    var end = parseInt(productsContainer.dataset.touchEnd);

    // Attempt to distinguish swipe from touch
    // Using a threshold of >10% of screen width from start to end
    if (Math.abs(start - end) > (screen.width / 10)) {
      if (start < end) {
        processCarouselDirection(collection, 'prev');
      } else if (start > end) {
        processCarouselDirection(collection, 'next');
      }
    }

    // Reset start and end
    productsContainer.dataset.touchStart = 0;
    productsContainer.dataset.touchEnd = 0;
  }

  function insertNode(collection, index, position) {
    var product = collection.querySelector('.products-container-all .product[data-index="' + index + '"]');
    if (product) {
      var clonedProduct = product.cloneNode(true);

      // Prepend/Append accordingly
      if (position === 'start') {
        collection.querySelector('.products-container').prepend(clonedProduct);
      } else {
        collection.querySelector('.products-container').append(clonedProduct);
      }
      
      // Add click event listener for product selection
      clonedProduct.addEventListener('click', handleProductSelectEvent);
    }
  }

  function removeNode(collection, index) {
    var product = collection.querySelector('.products-container .product[data-index="' + index + '"]');
    if (product) {
      product.removeEventListener('click', handleProductSelectEvent);
      product.remove();
    }
  }

  function init() {
    document.querySelectorAll('.fit-guide-carousel').forEach(function(carousel) {
      // Click events for collection selectors
      carousel.querySelectorAll('.collection-selector a').forEach(function(collectionLink) {
        collectionLink.addEventListener('click', handleCollectionSelectEvent);
      });

      // Event handlers for each collection wrapper
      carousel.querySelectorAll('.collection-wrapper').forEach(function(collection) {
        var productsContainer = collection.querySelector('.products-container');

        // Add initial products
        for (var i = 0; i < getNumProductsToShow(productsContainer); i++) {
          insertNode(collection, i);
        }

        // Click events for prev/next buttons
        var navButtons = collection.querySelectorAll('.nav-btn');
        navButtons.forEach(function(navButton) {
          navButton.addEventListener('click', handleCarouselNavEvent);
        });
    
        // Touch events for mobile swiping
        productsContainer.addEventListener('touchstart', handleTouchStartEvent);
        productsContainer.addEventListener('touchend', handleTouchEndEvent);
      });

      // Select first collection on page load
      carousel.querySelector('.collection-selector a').click();
    });
  }

  function unload() {
    document.querySelectorAll('.fit-guide-carousel').forEach(function(carousel) {
      // Clear existing products. `init()` should repopulate.
      carousel.querySelectorAll('.products-container').forEach(function(productsContainer) {
        productsContainer.replaceChildren();
      })
  
      // Click events for prev/next buttons
      var navButtons = carousel.querySelectorAll('.nav-btn');
      navButtons.forEach(function(navButton) {
        navButton.removeEventListener('click', handleCarouselNavEvent);
      });
  
      // Touch events for mobile swiping
      productsContainerMobile.removeEventListener('touchstart', handleTouchStartEvent);
      productsContainerMobile.removeEventListener('touchend', handleTouchEndEvent);
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', unload);
  }

  init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["measurements"] && !Shopify.designMode) return;
  try {
    
  function handleClickEvent(event) {
    var element = event.currentTarget;

    // Set type as selected
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      if (type.dataset.type == element.dataset.type) {
        type.classList.add('selected');
      } else {
        type.classList.remove('selected');
      }
    });

    // Show size chart for selected
    document.querySelectorAll('.measurements .measurements-size-charts-container table.size-chart').forEach(function(chart) {
      if (chart.dataset.type === element.dataset.type) {
        chart.classList.remove('hidden');
      } else {
        chart.classList.add('hidden');
      }
    });
  }

  function init() {
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      type.addEventListener('click', handleClickEvent);
    });

    var measurement = document.querySelector('.measurements .measurements-types-container a.measurement-type');
    if (measurement) {
      measurement.click();
    }
  }

  function unload() {
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      type.removeEventListener('click', handleClickEvent);
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', unload);
  }

  init();

  } catch(e) { console.error(e); }
})();
})();
